export default __webpack_public_path__ + "static/media/history-mobile-4.a44dfacc.png";